import { Theme } from "@material-ui/core"
import makeStyles from "@material-ui/core/styles/makeStyles"
import React, { useContext, useRef, useState } from "react"
import { CalendarContext } from "../context"
import { MoveProvider, MovePosition } from "./moveContext"
import cal from "clsx"

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
    },
    move: {
        cursor: "move",
    },
}))
interface ComponentProps {
    children?: React.ReactNode
}
const MoveWrap = (props: ComponentProps) => {
    const classes = useStyles()
    const { children } = props
    const { movableBoard, handleSetMovableBoard } = useContext(CalendarContext)
    const isMoving = movableBoard !== null && movableBoard.id
    const [ position, setPosition ] = useState<MovePosition | null>(null)
    const wrapRef = useRef(null)
    const handleChangePosition = (pos: MovePosition | null) => {
        setPosition(pos)
    }
    const handleMouseMove = (event: React.MouseEvent) => {
        if (isMoving) {
            const scrollY = (document.querySelector("#content") as HTMLElement).scrollTop
            handleChangePosition({
                x: event.clientX,
                y: event.clientY + scrollY,
            })
        }
    }
    const handleEndMove = () => {
        handleSetMovableBoard(null)
    }
    return (
        <MoveProvider
            value={{
                position,
                handleChangePosition,
            }}
        >
            <div
                className={cal(
                    classes.root,
                    isMoving && classes.move,
                )}
                ref={wrapRef}
                onMouseMove={handleMouseMove}
                onMouseUp={handleEndMove}
            >
                {children}
            </div>
        </MoveProvider>
    )
}

export default MoveWrap
